import { Component, computed, input, output } from '@angular/core';
import {
  GcAccordionComponent,
  GcIconComponent,
  GcTextComponent,
  GcToggleComponent,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';
import { InstallationReportSelfInspectionItem } from '../../model/installation-reporting-mdu-section.types';
import { FileMetaV2Response } from '../../model/installation-reporting-mdu-bff.entities';
import {
  completedConfiguredItemCount,
  isSelfInspectionAnswerComplete,
} from '../../state/self-inspection-answer.util';
import {
  ItemAnswer,
  SectionState,
} from '../../state/installation-reporting-mdu-section-state.types';
import { SelfInspectionItemComponent } from '../self-inspection-item/self-inspection-item.component';

@Component({
  selector: 'app-self-inspection-section',
  imports: [
    GcAccordionComponent,
    GcIconComponent,
    GcTextComponent,
    GcToggleComponent,
    IpoTranslatePipe,
    SelfInspectionItemComponent,
  ],
  templateUrl: './self-inspection-section.component.html',
  styleUrl: './self-inspection-section.component.scss',
})
export class SelfInspectionSectionComponent {
  sectionTitleKey = input.required<string>();
  items = input.required<InstallationReportSelfInspectionItem[]>();
  state = input.required<SectionState>();
  mutationLoadingState = input<Partial<Record<string, boolean>>>({});

  toggleShowControlled = output<boolean>();
  markDone = output<string>();
  markNotApplicable = output<{ itemId: string; comment: string }>();
  uploadFiles = output<{ itemId: string; files: File[] }>();
  undo = output<string>();
  viewAttachments = output<{
    itemId: string;
    attachments: FileMetaV2Response[];
  }>();

  completedCount = computed<number>(() =>
    completedConfiguredItemCount(this.items(), this.state().itemAnswers),
  );

  visibleItems = computed<InstallationReportSelfInspectionItem[]>(() => {
    if (!this.state().showControlled) {
      return this.items();
    }
    return this.items().filter((item) =>
      isSelfInspectionAnswerComplete(this.state().itemAnswers[item.id]),
    );
  });

  itemAnswer(itemId: string): ItemAnswer {
    return this.state().itemAnswers[itemId] ?? { completed: false, files: [] };
  }
}
